package com.neurobs.ccab

// This file is auto-generated by CCABSlickGenerator.generate
// DO NOT EDIT THIS FILE

import com.neurobs.util.{Guid, PlainDate, SecondsTimestamp}

package object db {

  /** Entity class storing rows of table accountTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param primaryEmail Database column primary_email SqlType(VARCHAR), Length(255,true)
   *  @param secondaryEmail Database column secondary_email SqlType(VARCHAR), Length(255,true)
   *  @param organization Database column organization SqlType(VARCHAR), Length(255,true)
   *  @param userDescription Database column user_description SqlType(VARCHAR), Length(255,true)
   *  @param accountUuid Database column account_uuid SqlType(BINARY)
   *  @param testStationPassword Database column test_station_password SqlType(BINARY)
   *  @param keyRegistry Database column key_registry SqlType(TEXT), Default(None) */
  case class AccountData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	primaryEmail: String,
  	secondaryEmail: String,
  	organization: String,
  	userDescription: String,
  	accountUuid: Guid,
  	testStationPassword: Guid,
  	keyRegistry: Option[String]
  )

  /** Entity class storing rows of table permissionTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param name Database column name SqlType(VARCHAR), Length(255,true)
   *  @param description Database column description SqlType(TEXT), Default(None) */
  case class PermissionData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	name: String,
  	description: Option[String]
  )

  /** Entity class storing rows of table rolePermissionTable
   *  @param roleId Database column role_id SqlType(BIGINT UNSIGNED)
   *  @param permissionId Database column permission_id SqlType(BIGINT UNSIGNED) */
  case class RolePermissionData
  (
  	roleId: Long,
  	permissionId: Long
  )

  /** Entity class storing rows of table roleTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param name Database column name SqlType(VARCHAR), Length(255,true)
   *  @param description Database column description SqlType(TEXT), Default(None) */
  case class RoleData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	name: String,
  	description: Option[String]
  )

  /** Entity class storing rows of table settingTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(64,true)
   *  @param displayName Database column display_name SqlType(VARCHAR), Length(255,true)
   *  @param description Database column description SqlType(TEXT)
   *  @param accountSetting Database column account_setting SqlType(TINYINT)
   *  @param userSetting Database column user_setting SqlType(TINYINT)
   *  @param visible Database column visible SqlType(TINYINT)
   *  @param values Database column values SqlType(VARCHAR), Length(255,true), Default(None) */
  case class SettingData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	identifier: String,
  	displayName: String,
  	description: String,
  	accountSetting: Boolean,
  	userSetting: Boolean,
  	visible: Boolean,
  	values: Option[String]
  )

  /** Entity class storing rows of table settingValueTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param settingId Database column setting_id SqlType(BIGINT UNSIGNED)
   *  @param userId Database column user_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param accountId Database column account_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param value Database column value SqlType(VARCHAR), Length(255,true) */
  case class SettingValueData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	settingId: Long,
  	userId: Option[Long],
  	accountId: Option[Long],
  	value: String
  )

  /** Entity class storing rows of table userAccountViewTable
   *  @param userId Database column user_id SqlType(BIGINT UNSIGNED), Default(0)
   *  @param userUuid Database column user_uuid SqlType(BINARY)
   *  @param userCreatedAt Database column user_created_at SqlType(DATETIME)
   *  @param username Database column username SqlType(VARCHAR), Length(64,true)
   *  @param passwordHash Database column password_hash SqlType(VARCHAR), Length(255,true)
   *  @param familyName Database column family_name SqlType(VARCHAR), Length(255,true), Default()
   *  @param givenName Database column given_name SqlType(VARCHAR), Length(255,true), Default()
   *  @param disabled Database column disabled SqlType(TINYINT), Default(false)
   *  @param migrated Database column migrated SqlType(TINYINT), Default(false)
   *  @param accountId Database column account_id SqlType(BIGINT UNSIGNED), Default(0)
   *  @param accountUuid Database column account_uuid SqlType(BINARY)
   *  @param accountCreatedAt Database column account_created_at SqlType(DATETIME)
   *  @param primaryEmail Database column primary_email SqlType(VARCHAR), Length(255,true)
   *  @param organization Database column organization SqlType(VARCHAR), Length(255,true)
   *  @param keyRegistryCreated Database column key_registry_created SqlType(INT), Default(0) */
  case class UserAccountViewData
  (
  	userId: Long,
  	userUuid: Guid,
  	userCreatedAt: SecondsTimestamp,
  	username: String,
  	passwordHash: String,
  	familyName: String,
  	givenName: String,
  	disabled: Boolean,
  	migrated: Boolean,
  	accountId: Long,
  	accountUuid: Guid,
  	accountCreatedAt: SecondsTimestamp,
  	primaryEmail: String,
  	organization: String,
  	keyRegistryCreated: Int
  )

  /** Entity class storing rows of table userRoleTable
   *  @param userId Database column user_id SqlType(BIGINT UNSIGNED)
   *  @param roleId Database column role_id SqlType(BIGINT UNSIGNED) */
  case class UserRoleData
  (
  	userId: Long,
  	roleId: Long
  )

  /** Entity class storing rows of table userTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param username Database column username SqlType(VARCHAR), Length(64,true)
   *  @param passwordHash Database column password_hash SqlType(VARCHAR), Length(255,true)
   *  @param accountId Database column account_id SqlType(BIGINT UNSIGNED)
   *  @param userUuid Database column user_uuid SqlType(BINARY)
   *  @param familyName Database column family_name SqlType(VARCHAR), Length(255,true), Default()
   *  @param givenName Database column given_name SqlType(VARCHAR), Length(255,true), Default()
   *  @param disabled Database column disabled SqlType(TINYINT), Default(false)
   *  @param migrated Database column migrated SqlType(TINYINT), Default(false) */
  case class UserData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	username: String,
  	passwordHash: String,
  	accountId: Long,
  	userUuid: Guid,
  	familyName: String,
  	givenName: String,
  	disabled: Boolean,
  	migrated: Boolean
  )

  /** Entity class storing rows of table accountStudyTable
   *  @param accountId Database column account_id SqlType(BIGINT UNSIGNED)
   *  @param studyId Database column study_id SqlType(BIGINT UNSIGNED) */
  case class AccountStudyData
  (
  	accountId: Long,
  	studyId: Long
  )

  /** Entity class storing rows of table accountSubjectTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param accountId Database column account_id SqlType(BIGINT UNSIGNED)
   *  @param subjectId Database column subject_id SqlType(BIGINT UNSIGNED)
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param encodedIdentity Database column encoded_identity SqlType(BLOB), Default(None)
   *  @param reportingId Database column reporting_id SqlType(BINARY)
   *  @param keyId Database column key_id SqlType(VARCHAR), Length(255,true), Default(None) */
  case class AccountSubjectData
  (
  	id: Long,
  	accountId: Long,
  	subjectId: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	encodedIdentity: Option[Array[Byte]],
  	reportingId: Guid,
  	keyId: Option[String]
  )

  /** Entity class storing rows of table accountSubjectViewTable
   *  @param accountSubjectId Database column account_subject_id SqlType(BIGINT UNSIGNED), Default(0)
   *  @param accountId Database column account_id SqlType(BIGINT UNSIGNED)
   *  @param subjectId Database column subject_id SqlType(BIGINT UNSIGNED), Default(0)
   *  @param accountSubjectCreatedAt Database column account_subject_created_at SqlType(DATETIME)
   *  @param encodedIdentity Database column encoded_identity SqlType(BLOB), Default(None)
   *  @param reportingId Database column reporting_id SqlType(BINARY)
   *  @param subjectCreatedAt Database column subject_created_at SqlType(DATETIME)
   *  @param birthYear Database column birth_year SqlType(INT), Default(None)
   *  @param sex Database column sex SqlType(ENUM), Length(2,false), Default(None) */
  case class AccountSubjectViewData
  (
  	accountSubjectId: Long,
  	accountId: Long,
  	subjectId: Long,
  	accountSubjectCreatedAt: SecondsTimestamp,
  	encodedIdentity: Option[Array[Byte]],
  	reportingId: Guid,
  	subjectCreatedAt: SecondsTimestamp,
  	birthYear: Option[Int],
  	sex: Option[Sex.Value]
  )

  /** Entity class storing rows of table dataKeyTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param accountId Database column account_id SqlType(BIGINT UNSIGNED)
   *  @param userId Database column user_id SqlType(BIGINT UNSIGNED)
   *  @param dataKey Database column data_key SqlType(VARBINARY)
   *  @param passwordKeyHash Database column password_key_hash SqlType(VARCHAR), Length(255,true) */
  case class DataKeyData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	accountId: Long,
  	userId: Long,
  	dataKey: Array[Byte],
  	passwordKeyHash: String
  )

  /** Entity class storing rows of table examinerTagTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(255,true)
   *  @param groupName Database column group_name SqlType(VARCHAR), Length(255,true)
   *  @param displayNameTestRun Database column display_name_test_run SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param displayNameSession Database column display_name_session SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param description Database column description SqlType(TEXT) */
  case class ExaminerTagData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	identifier: String,
  	groupName: String,
  	displayNameTestRun: Option[String],
  	displayNameSession: Option[String],
  	description: String
  )

  /** Entity class storing rows of table keyTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(64,true), Default(None)
   *  @param description Database column description SqlType(TEXT), Default(None)
   *  @param storageType Database column storage_type SqlType(ENUM), Length(6,false)
   *  @param data Database column data SqlType(VARBINARY), Default(None) */
  case class KeyData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	identifier: Option[String],
  	description: Option[String],
  	storageType: KeyStorageType.Value,
  	data: Option[Array[Byte]]
  )

  /** Entity class storing rows of table logfileStorageTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param contents Database column contents SqlType(MEDIUMBLOB)
   *  @param cryptKey Database column crypt_key SqlType(INT), Default(None) */
  case class LogfileStorageData
  (
  	id: Long,
  	contents: Array[Byte],
  	cryptKey: Option[Int]
  )

  /** Entity class storing rows of table logfileTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param startTime Database column start_time SqlType(DATETIME)
   *  @param subjectGuid Database column subject_guid SqlType(BINARY)
   *  @param packageGuid Database column package_guid SqlType(BINARY)
   *  @param experimentGuid Database column experiment_guid SqlType(BINARY)
   *  @param scenario Database column scenario SqlType(VARCHAR), Length(255,true)
   *  @param origFilename Database column orig_filename SqlType(VARCHAR), Length(255,true)
   *  @param location Database column location SqlType(TEXT), Default(None)
   *  @param logfileStorageId Database column logfile_storage_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param audioAttenuation Database column audio_attenuation SqlType(DOUBLE), Default(None)
   *  @param language Database column language SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param logIdentifier Database column log_identifier SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param computerName Database column computer_name SqlType(VARCHAR), Length(255,true), Default(None) */
  case class LogfileData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	startTime: SecondsTimestamp,
  	subjectGuid: Guid,
  	packageGuid: Guid,
  	experimentGuid: Guid,
  	scenario: String,
  	origFilename: String,
  	location: Option[String],
  	logfileStorageId: Option[Long],
  	audioAttenuation: Option[Double],
  	language: Option[String],
  	logIdentifier: Option[String],
  	computerName: Option[String]
  )

  /** Entity class storing rows of table sessionLogTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param contents Database column contents SqlType(MEDIUMBLOB)
   *  @param keyId Database column key_id SqlType(BIGINT UNSIGNED), Default(None) */
  case class SessionLogData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	contents: Array[Byte],
  	keyId: Option[Long]
  )

  /** Entity class storing rows of table sessionTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param startTime Database column start_time SqlType(DATETIME)
   *  @param accountId Database column account_id SqlType(BIGINT UNSIGNED)
   *  @param studyId Database column study_id SqlType(BIGINT UNSIGNED)
   *  @param accountSubjectId Database column account_subject_id SqlType(BIGINT UNSIGNED)
   *  @param stationUserId Database column station_user_id SqlType(BIGINT UNSIGNED)
   *  @param adminUserId Database column admin_user_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param stationName Database column station_name SqlType(VARCHAR), Length(255,true)
   *  @param accessGuid Database column access_guid SqlType(BINARY)
   *  @param subjectGuid Database column subject_guid SqlType(BINARY)
   *  @param properties Database column properties SqlType(TEXT), Default(None)
   *  @param sessionLogId Database column session_log_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param locationType Database column location_type SqlType(VARCHAR), Length(255,true), Default(None) */
  case class SessionData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	startTime: SecondsTimestamp,
  	accountId: Long,
  	studyId: Long,
  	accountSubjectId: Long,
  	stationUserId: Long,
  	adminUserId: Option[Long],
  	stationName: String,
  	accessGuid: Guid,
  	subjectGuid: Guid,
  	properties: Option[String],
  	sessionLogId: Option[Long],
  	locationType: Option[String]
  )

  /** Entity class storing rows of table studyTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param displayName Database column display_name SqlType(VARCHAR), Length(255,true)
   *  @param description Database column description SqlType(TEXT)
   *  @param studyTypeId Database column study_type_id SqlType(BIGINT UNSIGNED)
   *  @param active Database column active SqlType(TINYINT), Default(true)
   *  @param studyUuid Database column study_uuid SqlType(BINARY)
   *  @param config Database column config SqlType(TEXT), Default(None) */
  case class StudyData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	displayName: String,
  	description: String,
  	studyTypeId: Long,
  	active: Boolean,
  	studyUuid: Guid,
  	config: Option[String]
  )

  /** Entity class storing rows of table studyTypeTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param displayName Database column display_name SqlType(VARCHAR), Length(255,true)
   *  @param description Database column description SqlType(TEXT)
   *  @param studyTypeUuid Database column study_type_uuid SqlType(BINARY) */
  case class StudyTypeData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	displayName: String,
  	description: String,
  	studyTypeUuid: Guid
  )

  /** Entity class storing rows of table subjectTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param birthYear Database column birth_year SqlType(INT), Default(None)
   *  @param sex Database column sex SqlType(ENUM), Length(2,false), Default(None) */
  case class SubjectData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	birthYear: Option[Int],
  	sex: Option[Sex.Value]
  )

  /** Entity class storing rows of table testAnalysisTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param testRunId Database column test_run_id SqlType(BIGINT UNSIGNED)
   *  @param testId Database column test_id SqlType(BIGINT UNSIGNED)
   *  @param sessionId Database column session_id SqlType(BIGINT UNSIGNED)
   *  @param testTranscriptId Database column test_transcript_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param reviewedTestTranscriptId Database column reviewed_test_transcript_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param analyzerVersion Database column analyzer_version SqlType(INT UNSIGNED), Default(None)
   *  @param error Database column error SqlType(TEXT), Default(None)
   *  @param results Database column results SqlType(MEDIUMTEXT), Length(16777215,true), Default(None)
   *  @param transcriptUsed Database column transcript_used SqlType(TINYINT), Default(None) */
  case class TestAnalysisData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	testRunId: Long,
  	testId: Long,
  	sessionId: Long,
  	testTranscriptId: Option[Long],
  	reviewedTestTranscriptId: Option[Long],
  	analyzerVersion: Option[Long],
  	error: Option[String],
  	results: Option[String],
  	transcriptUsed: Option[Boolean]
  )

  /** Entity class storing rows of table testRunLogfileTable
   *  @param testRunId Database column test_run_id SqlType(BIGINT UNSIGNED)
   *  @param logfileId Database column logfile_id SqlType(BIGINT UNSIGNED) */
  case class TestRunLogfileData
  (
  	testRunId: Long,
  	logfileId: Long
  )

  /** Entity class storing rows of table testRunTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param sessionId Database column session_id SqlType(BIGINT UNSIGNED)
   *  @param startTime Database column start_time SqlType(DATETIME)
   *  @param packageGuid Database column package_guid SqlType(BINARY)
   *  @param softwareVersion Database column software_version SqlType(VARCHAR), Length(45,true)
   *  @param testId Database column test_id SqlType(BIGINT UNSIGNED)
   *  @param completed Database column completed SqlType(TINYINT), Default(None)
   *  @param analyzed Database column analyzed SqlType(TINYINT), Default(false)
   *  @param runError Database column run_error SqlType(TEXT), Default(None)
   *  @param analysisError Database column analysis_error SqlType(TEXT), Default(None)
   *  @param language Database column language SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param logIdentifier Database column log_identifier SqlType(VARCHAR), Length(255,true), Default(None) */
  case class TestRunData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	sessionId: Long,
  	startTime: SecondsTimestamp,
  	packageGuid: Guid,
  	softwareVersion: String,
  	testId: Long,
  	completed: Option[Boolean],
  	analyzed: Boolean,
  	runError: Option[String],
  	analysisError: Option[String],
  	language: Option[String],
  	logIdentifier: Option[String]
  )

  /** Entity class storing rows of table testTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(255,true)
   *  @param displayName Database column display_name SqlType(VARCHAR), Length(255,true)
   *  @param description Database column description SqlType(TEXT) */
  case class TestData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	identifier: String,
  	displayName: String,
  	description: String
  )

  /** Entity class storing rows of table releaseTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param releaseTypeId Database column release_type_id SqlType(BIGINT UNSIGNED)
   *  @param active Database column active SqlType(TINYINT)
   *  @param version Database column version SqlType(VARCHAR), Length(255,true)
   *  @param storageKey Database column storage_key SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param dependency1MinVersion Database column dependency1_min_version SqlType(VARCHAR), Length(255,true)
   *  @param releaseNotes Database column release_notes SqlType(TEXT)
   *  @param buildId Database column build_id SqlType(BINARY), Default(None)
   *  @param releaseDate Database column release_date SqlType(DATE), Default(None) */
  case class ReleaseData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	releaseTypeId: Long,
  	active: Boolean,
  	version: String,
  	storageKey: Option[String],
  	dependency1MinVersion: String,
  	releaseNotes: String,
  	buildId: Option[Guid],
  	releaseDate: Option[PlainDate]
  )

  /** Entity class storing rows of table releaseTypeTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param displayName Database column display_name SqlType(VARCHAR), Length(255,true)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(255,true)
   *  @param storageFolder Database column storage_folder SqlType(VARCHAR), Length(255,true)
   *  @param dependency1Description Database column dependency1_description SqlType(VARCHAR), Length(255,true), Default(None) */
  case class ReleaseTypeData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	displayName: String,
  	identifier: String,
  	storageFolder: String,
  	dependency1Description: Option[String]
  )

  /** Entity class storing rows of table errorClassTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(64,true)
   *  @param description Database column description SqlType(VARCHAR), Length(255,true) */
  case class ErrorClassData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	identifier: String,
  	description: String
  )

  /** Entity class storing rows of table errorTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param eventTime Database column event_time SqlType(DATETIME)
   *  @param errorClassId Database column error_class_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param errorTypeId Database column error_type_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param `class` Database column class SqlType(VARCHAR), Length(64,true)
   *  @param `type` Database column type SqlType(VARCHAR), Length(64,true)
   *  @param content Database column content SqlType(TEXT)
   *  @param contentType Database column content_type SqlType(VARCHAR), Length(128,true) */
  case class ErrorData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	eventTime: SecondsTimestamp,
  	errorClassId: Option[Long],
  	errorTypeId: Option[Long],
  	`class`: String,
  	`type`: String,
  	content: String,
  	contentType: String
  )

  /** Entity class storing rows of table errorTypeTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(64,true)
   *  @param description Database column description SqlType(VARCHAR), Length(255,true) */
  case class ErrorTypeData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	identifier: String,
  	description: String
  )

  /** Entity class storing rows of table eventServerEventTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param eventTime Database column event_time SqlType(DATETIME), Default(None)
   *  @param receivedTime Database column received_time SqlType(DATETIME)
   *  @param eventType Database column event_type SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param eventSource Database column event_source SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param eventFramework Database column event_framework SqlType(VARCHAR), Length(255,true)
   *  @param content Database column content SqlType(TEXT)
   *  @param processed Database column processed SqlType(DATETIME), Default(None)
   *  @param errorId Database column error_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param retryId Database column retry_id SqlType(BIGINT UNSIGNED), Default(None) */
  case class EventServerEventData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	eventTime: Option[SecondsTimestamp],
  	receivedTime: SecondsTimestamp,
  	eventType: Option[String],
  	eventSource: Option[String],
  	eventFramework: String,
  	content: String,
  	processed: Option[SecondsTimestamp],
  	errorId: Option[Long],
  	retryId: Option[Long]
  )

  /** Entity class storing rows of table eventTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param `type` Database column type SqlType(VARCHAR), Length(255,true)
   *  @param subType Database column sub_type SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param startEventId Database column start_event_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param content Database column content SqlType(TEXT), Default(None)
   *  @param contentType Database column content_type SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param errorId Database column error_id SqlType(BIGINT UNSIGNED), Default(None) */
  case class EventData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	`type`: String,
  	subType: Option[String],
  	startEventId: Option[Long],
  	content: Option[String],
  	contentType: Option[String],
  	errorId: Option[Long]
  )

  /** Entity class storing rows of table asrConfigurationTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param data Database column data SqlType(TEXT)
   *  @param asrEngineId Database column asr_engine_id SqlType(BIGINT UNSIGNED) */
  case class AsrConfigurationData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	data: String,
  	asrEngineId: Long
  )

  /** Entity class storing rows of table asrEngineTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param displayName Database column display_name SqlType(VARCHAR), Length(255,true)
   *  @param description Database column description SqlType(TEXT)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(64,true)
   *  @param dollarsPerMinute Database column dollars_per_minute SqlType(DECIMAL)
   *  @param roundingSecs Database column rounding_secs SqlType(INT), Default(None) */
  case class AsrEngineData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	displayName: String,
  	description: String,
  	identifier: String,
  	dollarsPerMinute: scala.math.BigDecimal,
  	roundingSecs: Option[Int]
  )

  /** Entity class storing rows of table asrVocabularyTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param data Database column data SqlType(MEDIUMTEXT), Length(16777215,true) */
  case class AsrVocabularyData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	data: String
  )

  /** Entity class storing rows of table casrReleaseTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param version Database column version SqlType(VARCHAR), Length(30,true) */
  case class CasrReleaseData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	version: String
  )

  /** Entity class storing rows of table fileTranscriptRequestTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param backlog Database column backlog SqlType(TINYINT), Default(false)
   *  @param completedAt Database column completed_at SqlType(DATETIME), Default(None)
   *  @param asrConfigurationId Database column asr_configuration_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param asrEngineId Database column asr_engine_id SqlType(BIGINT UNSIGNED)
   *  @param asrVocabularyId Database column asr_vocabulary_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param speechAudioFileId Database column speech_audio_file_id SqlType(BIGINT UNSIGNED)
   *  @param retryId Database column retry_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param language Database column language SqlType(VARCHAR), Length(255,true), Default(en-US)
   *  @param testIden Database column test_iden SqlType(VARCHAR), Length(255,true), Default(None) */
  case class FileTranscriptRequestData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	backlog: Boolean,
  	completedAt: Option[SecondsTimestamp],
  	asrConfigurationId: Option[Long],
  	asrEngineId: Long,
  	asrVocabularyId: Option[Long],
  	speechAudioFileId: Long,
  	retryId: Option[Long],
  	language: String,
  	testIden: Option[String]
  )

  /** Entity class storing rows of table fileTranscriptResponseTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param cost Database column cost SqlType(DECIMAL)
   *  @param error Database column error SqlType(TEXT), Default(None)
   *  @param fileTranscriptId Database column file_transcript_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param fileTranscriptRequestId Database column file_transcript_request_id SqlType(BIGINT UNSIGNED)
   *  @param responseTypeId Database column response_type_id SqlType(BIGINT UNSIGNED)
   *  @param processed Database column processed SqlType(DATETIME), Default(None) */
  case class FileTranscriptResponseData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	cost: scala.math.BigDecimal,
  	error: Option[String],
  	fileTranscriptId: Option[Long],
  	fileTranscriptRequestId: Long,
  	responseTypeId: Long,
  	processed: Option[SecondsTimestamp]
  )

  /** Entity class storing rows of table fileTranscriptTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param durationMs Database column duration_ms SqlType(INT)
   *  @param fileSamplingRateHz Database column file_sampling_rate_hz SqlType(INT)
   *  @param fileChannels Database column file_channels SqlType(INT)
   *  @param engineSamplingRateHz Database column engine_sampling_rate_hz SqlType(INT)
   *  @param engineChannels Database column engine_channels SqlType(INT)
   *  @param transcript Database column transcript SqlType(MEDIUMTEXT), Length(16777215,true)
   *  @param asrConfigurationId Database column asr_configuration_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param asrEngineId Database column asr_engine_id SqlType(BIGINT UNSIGNED)
   *  @param asrVocabularyId Database column asr_vocabulary_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param speechAudioFileId Database column speech_audio_file_id SqlType(BIGINT UNSIGNED)
   *  @param language Database column language SqlType(VARCHAR), Length(255,true), Default(en-US)
   *  @param testIden Database column test_iden SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param softwareVersion Database column software_version SqlType(INT), Default(1)
   *  @param configVersion Database column config_version SqlType(INT), Default(1) */
  case class FileTranscriptData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	durationMs: Int,
  	fileSamplingRateHz: Int,
  	fileChannels: Int,
  	engineSamplingRateHz: Int,
  	engineChannels: Int,
  	transcript: String,
  	asrConfigurationId: Option[Long],
  	asrEngineId: Long,
  	asrVocabularyId: Option[Long],
  	speechAudioFileId: Long,
  	language: String,
  	testIden: Option[String],
  	softwareVersion: Int,
  	configVersion: Int
  )

  /** Entity class storing rows of table responseTypeTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(64,true)
   *  @param description Database column description SqlType(TEXT)
   *  @param retry Database column retry SqlType(TINYINT)
   *  @param logExternalError Database column log_external_error SqlType(TINYINT) */
  case class ResponseTypeData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	identifier: String,
  	description: String,
  	retry: Boolean,
  	logExternalError: Boolean
  )

  /** Entity class storing rows of table reviewedTestTranscriptTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param testRunId Database column test_run_id SqlType(BIGINT UNSIGNED)
   *  @param userId Database column user_id SqlType(BIGINT UNSIGNED)
   *  @param transcript Database column transcript SqlType(MEDIUMTEXT), Length(16777215,true)
   *  @param forLatency Database column for_latency SqlType(TINYINT)
   *  @param needsSync Database column needs_sync SqlType(TINYINT) */
  case class ReviewedTestTranscriptData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	testRunId: Long,
  	userId: Long,
  	transcript: String,
  	forLatency: Boolean,
  	needsSync: Boolean
  )

  /** Entity class storing rows of table speechAudioFileTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param filename Database column filename SqlType(VARCHAR), Length(255,true)
   *  @param location Database column location SqlType(VARCHAR), Length(255,true), Default(None) */
  case class SpeechAudioFileData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	filename: String,
  	location: Option[String]
  )

  /** Entity class storing rows of table testRunSpeechAudioFileTable
   *  @param testRunId Database column test_run_id SqlType(BIGINT UNSIGNED)
   *  @param speechAudioFileId Database column speech_audio_file_id SqlType(BIGINT UNSIGNED) */
  case class TestRunSpeechAudioFileData
  (
  	testRunId: Long,
  	speechAudioFileId: Long
  )

  /** Entity class storing rows of table testTranscriptFileTranscriptTable
   *  @param testTranscriptId Database column test_transcript_id SqlType(BIGINT UNSIGNED)
   *  @param fileTranscriptId Database column file_transcript_id SqlType(BIGINT UNSIGNED) */
  case class TestTranscriptFileTranscriptData
  (
  	testTranscriptId: Long,
  	fileTranscriptId: Long
  )

  /** Entity class storing rows of table testTranscriptTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param casrReleaseId Database column casr_release_id SqlType(BIGINT UNSIGNED)
   *  @param testRunId Database column test_run_id SqlType(BIGINT UNSIGNED)
   *  @param completedAt Database column completed_at SqlType(DATETIME), Default(None)
   *  @param transcript Database column transcript SqlType(MEDIUMTEXT), Length(16777215,true), Default(None)
   *  @param error Database column error SqlType(MEDIUMTEXT), Length(16777215,true), Default(None)
   *  @param processed Database column processed SqlType(DATETIME), Default(None)
   *  @param needsSync Database column needs_sync SqlType(TINYINT)
   *  @param language Database column language SqlType(VARCHAR), Length(255,true), Default(en-US)
   *  @param testIden Database column test_iden SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param softwareVersion Database column software_version SqlType(INT), Default(1)
   *  @param configVersion Database column config_version SqlType(INT), Default(1)
   *  @param asrEngines Database column asr_engines SqlType(VARCHAR), Length(255,true), Default(None) */
  case class TestTranscriptData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	casrReleaseId: Long,
  	testRunId: Long,
  	completedAt: Option[SecondsTimestamp],
  	transcript: Option[String],
  	error: Option[String],
  	processed: Option[SecondsTimestamp],
  	needsSync: Boolean,
  	language: String,
  	testIden: Option[String],
  	softwareVersion: Int,
  	configVersion: Int,
  	asrEngines: Option[String]
  )

  /** Entity class storing rows of table languageTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param displayName Database column display_name SqlType(VARCHAR), Length(64,true)
   *  @param description Database column description SqlType(TEXT), Default(None) */
  case class LanguageData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	displayName: String,
  	description: Option[String]
  )

  /** Entity class storing rows of table phraseGroupProductVersionTable
   *  @param phraseGroupId Database column phrase_group_id SqlType(BIGINT UNSIGNED)
   *  @param productVersionId Database column product_version_id SqlType(BIGINT UNSIGNED) */
  case class PhraseGroupProductVersionData
  (
  	phraseGroupId: Long,
  	productVersionId: Long
  )

  /** Entity class storing rows of table phraseGroupTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(64,true)
   *  @param displayName Database column display_name SqlType(VARCHAR), Length(64,true)
   *  @param description Database column description SqlType(TEXT) */
  case class PhraseGroupData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	identifier: String,
  	displayName: String,
  	description: String
  )

  /** Entity class storing rows of table phrasePhraseGroupTable
   *  @param phraseId Database column phrase_id SqlType(BIGINT UNSIGNED)
   *  @param phraseGroupId Database column phrase_group_id SqlType(BIGINT UNSIGNED)
   *  @param phraseIndex Database column phrase_index SqlType(INT) */
  case class PhrasePhraseGroupData
  (
  	phraseId: Long,
  	phraseGroupId: Long,
  	phraseIndex: Int
  )

  /** Entity class storing rows of table phraseTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param text Database column text SqlType(TEXT)
   *  @param tags Database column tags SqlType(VARCHAR), Length(255,true), Default(None)
   *  @param notes Database column notes SqlType(TEXT), Default(None) */
  case class PhraseData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	text: String,
  	tags: Option[String],
  	notes: Option[String]
  )

  /** Entity class storing rows of table productTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param displayName Database column display_name SqlType(VARCHAR), Length(64,true)
   *  @param description Database column description SqlType(TEXT), Default(None) */
  case class ProductData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	displayName: String,
  	description: Option[String]
  )

  /** Entity class storing rows of table productVersionTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param productId Database column product_id SqlType(BIGINT UNSIGNED)
   *  @param version Database column version SqlType(DECIMAL) */
  case class ProductVersionData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	productId: Long,
  	version: scala.math.BigDecimal
  )

  /** Entity class storing rows of table translationEngineTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param identifier Database column identifier SqlType(VARCHAR), Length(64,true)
   *  @param displayName Database column display_name SqlType(VARCHAR), Length(64,true)
   *  @param description Database column description SqlType(TEXT), Default(None) */
  case class TranslationEngineData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	identifier: String,
  	displayName: String,
  	description: Option[String]
  )

  /** Entity class storing rows of table translationTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param phraseId Database column phrase_id SqlType(BIGINT UNSIGNED)
   *  @param languageId Database column language_id SqlType(BIGINT UNSIGNED)
   *  @param translationEngineId Database column translation_engine_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param translatorId Database column translator_id SqlType(BIGINT UNSIGNED), Default(None)
   *  @param text Database column text SqlType(TEXT)
   *  @param notes Database column notes SqlType(TEXT), Default(None) */
  case class TranslationData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	phraseId: Long,
  	languageId: Long,
  	translationEngineId: Option[Long],
  	translatorId: Option[Long],
  	text: String,
  	notes: Option[String]
  )

  /** Entity class storing rows of table translatorTable
   *  @param id Database column id SqlType(BIGINT UNSIGNED), AutoInc, PrimaryKey
   *  @param createdAt Database column created_at SqlType(DATETIME)
   *  @param userId Database column user_id SqlType(BIGINT UNSIGNED)
   *  @param languageId Database column language_id SqlType(BIGINT UNSIGNED)
   *  @param active Database column active SqlType(TINYINT) */
  case class TranslatorData
  (
  	id: Long,
  	createdAt: SecondsTimestamp = SecondsTimestamp.now(),
  	userId: Long,
  	languageId: Long,
  	active: Boolean
  )

}